import React from "react";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectIsAuthenticated, selectLoading } from "../../store/adminState/selector";
import LoginPage from "../../presentational/pages/admin-view/login";
import { loginSSO } from "../../store/adminState/actions";

interface Props {}

export interface LoginProps {
  loading: boolean;
  onSSOLogin(): void;
}

const Login: React.FC<Props> = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectLoading);
  const dispatch = useDispatch();

  const onSSOLogin = async () => {
    if (loading) return
    dispatch(loginSSO())
  }

  const loginProps: LoginProps = {
    loading: loading,
    onSSOLogin: onSSOLogin
  };

  return isAuthenticated ? <Redirect to="/event-overview" /> : <LoginPage {...loginProps} />;
};

export default Login;